const state = {
    merchant: [],
    stripe_id: null,
    stripe_onboarding: null
}

const getters = {
    merchant: state => state.merchant,
    stripe_id: state => state.stripe_id,
    stripe_onboarding: state => state.stripe_onboarding,
}

const actions = {
    fetchMerchant({ commit }) {
        return axios.get('/user/'+Vue.auth.user().id+'/merchant').then((res) => commit('SET_MERCHANT', res.data.data))
    },
    updateMerchant({ commit },form) {
        return axios.put('/merchant/'+Vue.auth.user().merchant_id,form)
    },
    newMerchant({ commit },form) {
        return axios.post('/merchant',form)
    },

    async createStripeAccount({ commit, rootState }, payload) {
        // if first time, create account and redirects to stipe
        await axios
            .post('/create-stripe-account', payload)
            .then((res) => {
                window.location.href = res.data;
            });
    },

    async getStripeId({ commit, rootState }, payload) {
        const stripe_infos = await axios.post('/get-stripe-id', payload)
            .then((res) => res.data)

        commit('SET_STRIPE_ID', stripe_infos.stripe_account_id);
        commit('SET_STRIPE_ONBOARDING', stripe_infos.stripe_onboarding);
    },

    async checkStripeOnboarding({ commit, rootState }, payload) {
        const onboarding = await axios.post('/check-stripe-onboarding', payload)
            .then((res) => res.data)

        commit('SET_STRIPE_ONBOARDING', onboarding);
        commit('SET_MERCHANT_STRIPE_ONBOARDING', onboarding);
    },
}

const mutations = {
    SET_MERCHANT: (state, merchant) => (state.merchant = merchant),
    SET_STRIPE_ID: (state, value) => (state.stripe_id = value),
    SET_STRIPE_ONBOARDING: (state, value) => (state.stripe_onboarding = value),
    SET_MERCHANT_STRIPE_ONBOARDING: (state, value) => {
        Vue.set(Vue.auth.user().merchant, 'stripe_onboarding', value);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
